import { shouldGetPricingRedirectPageTest } from "services/ab-tests/acquisition-ab-test-service";
import { PLATFORM_PRICING_PAGE_REDIRECT_TEST } from "constants/new-ab-tests";
import {
  PLATFORM_VISITOR_AB_TEST_NAME_PARAM_NAME,
  PLATFORM_VISITOR_AB_TEST_VARIANT_PARAM_NAME
} from "constants/welcome-page-constants";
import { LAST_ACCOUNT_SLUG, IS_PAYING_ACCOUNT_COOKIE_NAME } from "constants/cookies";
import { getSlugDataInlineScript } from "/utils/inline-scripts";

const platformDomain = process.env.PLATFORM_DOMAIN;

const RedirectToPlatfromScript = ({ abTests, persistantCookies }) => {
  const shouldRedirectToPlatformPricingPage = shouldGetPricingRedirectPageTest(abTests, persistantCookies);
  const isPayingAccount = persistantCookies[IS_PAYING_ACCOUNT_COOKIE_NAME];

  const redirectToPlatformPricingIfInTest = () => {
    const platformTestParams = `?${PLATFORM_VISITOR_AB_TEST_NAME_PARAM_NAME}=${PLATFORM_PRICING_PAGE_REDIRECT_TEST.test_name}&${PLATFORM_VISITOR_AB_TEST_VARIANT_PARAM_NAME}=${PLATFORM_PRICING_PAGE_REDIRECT_TEST.new_variation_name}`;

    if (shouldRedirectToPlatformPricingPage && !isPayingAccount) {
      // else we're not redirecting and not overriding appUrl
      return `
          const platformPricingUrl = "//"+lastActiveSlug + ".${platformDomain}/pricing_page${platformTestParams}";
          window.location.replace(platformPricingUrl);
      `;
    }
    return ` // do nothing - not in redirect variant `;
  };

  const redirectToPlatformIfNeeded = () => {
    return `
        ${getSlugDataInlineScript}
        const lastActiveSlug = cookieValueByName('${LAST_ACCOUNT_SLUG}');  // cookieValueByName defined inside getSlugDataInlineScript
 
        const preventRedirect = window.location.search.indexOf('no-redirect') > 0;

        if(lastActiveSlug && !preventRedirect) {
          var appUrl = "//"+lastActiveSlug + ".${platformDomain}";
          var path = window.location.pathname.trim();;

          const isPricingPage = path.includes("pricing");
          if (isPricingPage) {
            ${redirectToPlatformPricingIfInTest()}
          }
          else {
            window.location.replace(appUrl);
          }
        }
    `;
  };

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: redirectToPlatformIfNeeded()
      }}
    />
  );
};

export default RedirectToPlatfromScript;
